import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomCcCircular = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12m8.5-1c.28 0 .5-.22.5-.5V10c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-.5c0-.28-.22-.5-.5-.5H10c-.28 0-.5.22-.5.5h-2v-3h2c0 .28.22.5.5.5zm7 0c.28 0 .5-.22.5-.5V10c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-.5c0-.28-.22-.5-.5-.5H17c-.28 0-.5.22-.5.5h-2v-3h2c0 .28.22.5.5.5z"
  />,
  'CustomCcCircular',
);

export default CustomCcCircular;
